import * as React from "react";
const CartFill = (props) => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 8.03427V7.06427C7.5 4.81427 9.31 2.60427 11.56 2.39427C14.24 2.13427 16.5 4.24427 16.5 6.87427V8.25427"
      stroke="#FF6A4B"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.99983 22.3643H14.9998C19.0198 22.3643 19.7398 20.7543 19.9498 18.7943L20.6998 12.7943C20.9698 10.3543 20.2698 8.36426 15.9998 8.36426H7.99983C3.72983 8.36426 3.02983 10.3543 3.29983 12.7943L4.04983 18.7943C4.25983 20.7543 4.97983 22.3643 8.99983 22.3643Z"
      fill="#FF6A4B"
    />
    <path
      d="M15.4955 12.3643H15.5045"
      stroke="white"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.49414 12.3643H8.50312"
      stroke="white"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CartFill;
